import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/DefaultSelectDropdown";
import { usePlatformTranslation } from "@/hooks/usePlatformTranslation";
import { ViewDisplayMode } from "../types";

interface ViewModeSelectorProps {
  viewDisplayMode: ViewDisplayMode;
  onViewModeChange: (mode: ViewDisplayMode) => void;
  availableViewModes: string[];
  inline?: boolean;
}

/**
 * View Mode Selector component
 * Allows switching between different view modes (structured, documentation, code previews, JSON)
 */
export const ViewModeSelector: React.FC<ViewModeSelectorProps> = ({
  viewDisplayMode,
  onViewModeChange,
  availableViewModes,
  inline = false,
}) => {
  const { t } = usePlatformTranslation();

  return (
    <div className={inline ? "max-w-4xl mx-auto px-6 pt-4 pb-2" : "pb-2"}>
      <Select
        value={viewDisplayMode}
        onValueChange={(value) =>
          onViewModeChange(value as ViewDisplayMode)
        }
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue
            placeholder={t("platform.common.view_mode")}
          />
        </SelectTrigger>
        <SelectContent>
          {availableViewModes.includes("structured") && (
            <SelectItem value="structured">
              {t("platform.common.normal_view")}
            </SelectItem>
          )}
          {availableViewModes.includes("structured") && (
            <SelectItem value="documentation">
              {t("platform.common.Documentation_view")}
            </SelectItem>
          )}
          {availableViewModes.includes("unity") && (
            <SelectItem value="unity">
              {t("platform.common.unity_code")}
            </SelectItem>
          )}
          {availableViewModes.includes("godot") && (
            <SelectItem value="godot">
              {t("platform.common.godot_code")}
            </SelectItem>
          )}
          {availableViewModes.includes("cpp") && (
            <SelectItem value="cpp">
              {t("platform.common.c++_code")}
            </SelectItem>
          )}
          {availableViewModes.includes("typescript") && (
            <SelectItem value="typescript">
              {t("platform.common.typescript_code")}
            </SelectItem>
          )}
          {availableViewModes.includes("roblox") && (
            <SelectItem value="roblox">
              {t("platform.common.roblox_code")}
            </SelectItem>
          )}
          {availableViewModes.includes("json") && (
            <SelectItem value="json">
              {t("platform.common.json_structure")}
            </SelectItem>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

